import React from 'react';
import { Divider, Typography } from '@mui/material';

export const OrDivider: React.FC = () => {
    return (
        <Divider sx={{ width: '100%', my: 2 }}>
            <Typography variant="body2" color="text.secondary">
                OR
            </Typography>
        </Divider>
    );
};
